import { render } from "./MainThietBi.vue?vue&type=template&id=7c159d1e&scoped=true"
import script from "./MainThietBi.vue?vue&type=script&lang=js"
export * from "./MainThietBi.vue?vue&type=script&lang=js"

import "./MainThietBi.vue?vue&type=style&index=0&id=7c159d1e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c159d1e"]])

export default __exports__